import { __rest } from "tslib";
import { PREVIEW_PRODUCTS_SEARCH_PAGE_SIZE, PreviewModelType, PreviewType } from '@/search-for-retail/common/preview-panel/preview-panel.constants';
import { formatRule } from '@/search-for-retail/rule/rule.formatters';
import { formatDefineBiasItems } from '@/search-for-retail/biasing-strategy/biasing-strategy.formatters';
import { SearchForRetail } from '@/constants';
import { NavigationType } from '@/search-for-retail/evaluate/models';
export const getFormatter = (type) => {
    const formatterConfigMap = {
        [PreviewModelType.Rules]: formatRule,
        [PreviewModelType.BiasingStrategies]: formatDefineBiasItems,
    };
    return { formatter: formatterConfigMap[type] };
};
export const transformNavigationTriggersToRefinements = (triggerSets) => {
    const newArray = [];
    for (const triggerSet of triggerSets) {
        for (const trigger of triggerSet) {
            if (trigger.triggerType === SearchForRetail.TriggerType.NAVIGATION_VALUE && trigger.field) {
                newArray.push({
                    navigationName: trigger.field,
                    value: trigger.value,
                    displayName: trigger.field,
                    type: NavigationType.Value,
                    or: false,
                });
            }
        }
    }
    return newArray;
};
export const formatSearchConfig = (_a, previewType) => {
    var _b;
    var { browseCategories, page, modelValues } = _a, searchConfig = __rest(_a, ["browseCategories", "page", "modelValues"]);
    const { formatter } = getFormatter(modelValues.type);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (!modelValues.overwrite && {
        [modelValues.type]: formatter(modelValues.values),
    })), (browseCategories && {
        pageCategories: [browseCategories],
    })), { pageSize: PREVIEW_PRODUCTS_SEARCH_PAGE_SIZE, skip: (page - 1) * ((_b = searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.pageSize) !== null && _b !== void 0 ? _b : PREVIEW_PRODUCTS_SEARCH_PAGE_SIZE) }), (modelValues.overwrite && {
        overwrites: {
            [modelValues.type]: [
                formatter(modelValues.values),
            ],
        },
    })), (modelValues.type === PreviewModelType.Rules && previewType === PreviewType.Browse && {
        refinements: transformNavigationTriggersToRefinements(modelValues.values.triggerSets || []),
    })), searchConfig), { customUrlParams: searchConfig.customUrlParams.filter((param) => param.key && param.value) }), (previewType === PreviewType.Browse && {
        query: '',
    }));
};
